export default __webpack_public_path__ + "static/media/emission-highlighted-icon.caebdbe7.svg";